import { createReducer } from '@reduxjs/toolkit';
import { setHasUserTimedOut } from 'actionCreators/userSession';

const initialState = {
  hasTimedOut: false
};

const userSessionReducer = createReducer(initialState, (builder) => {
  builder.addCase(setHasUserTimedOut, () => {
    return {
      hasTimedOut: true
    };
  });
});

export { userSessionReducer };
